var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { Column, Sorting, FilterRow, Scrolling } from 'devextreme-react/data-grid';
import { Grid } from '@app/Components/Grid/Grid';
import { Api } from '@app/Api';
import { CompletionType, PromiseCompletion } from '@app/Classes/PromiseCompletion';
import { Link } from '@app/Components/Link/Link';
export var MyFunctionChecklists = /** @class */ (function (_super) {
    __extends(MyFunctionChecklists, _super);
    function MyFunctionChecklists() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._functionalChecklists = [];
        _this._promiseLoaded = new PromiseCompletion(CompletionType.Completed);
        return _this;
    }
    MyFunctionChecklists.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadFunctionalChecklists()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MyFunctionChecklists.prototype._loadFunctionalChecklists = function () {
        return __awaiter(this, void 0, void 0, function () {
            var functionalChecklistsRequest, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        functionalChecklistsRequest = Api.secured.getFunctionalChecklistsForCurrentPrincipal();
                        this._promiseLoaded.subscribe(functionalChecklistsRequest);
                        _a = this;
                        return [4 /*yield*/, functionalChecklistsRequest];
                    case 1:
                        _a._functionalChecklists = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MyFunctionChecklists.prototype.render = function () {
        return (React.createElement(Grid, { dataSource: this._functionalChecklists, loading: this._promiseLoaded.isPending, summary: {
                totalItems: [
                    {
                        column: 'Project',
                        summaryType: 'count',
                        customizeText: function (data) {
                            return "Total Function Checklists: ".concat(data.value);
                        }
                    }
                ]
            }, style: { maxHeight: '300px' } },
            React.createElement(Scrolling, { mode: "virtual" }),
            React.createElement(Sorting, { mode: "multiple" }),
            React.createElement(FilterRow, { visible: true }),
            React.createElement(Column, { caption: "Project", dataField: "projectFullDisplayName", cellRender: function (_a) {
                    var data = _a.data;
                    return (React.createElement(Link, { to: "/projects/".concat(data.projectCode) }, data.projectFullDisplayName));
                } }),
            React.createElement(Column, { caption: "Project Management", dataField: "projectManagementDisplayName", width: 180 }),
            React.createElement(Column, { caption: "Gate", dataField: "gateDisplayName", width: 80, alignment: "center" }),
            React.createElement(Column, { caption: "Gate Status", dataField: "gateStatus", width: 90 }),
            React.createElement(Column, { caption: "Checklist", dataField: "checklistCode", width: 80 }),
            React.createElement(Column, { caption: "Checklist Status", dataField: "checklistStatus", width: 90 }),
            React.createElement(Column, { caption: "Gate Assessor", dataField: "gateAssessorDisplayName" }),
            React.createElement(Column, { caption: "My Function", dataField: "functionCode", width: 105 })));
    };
    __decorate([
        observable
    ], MyFunctionChecklists.prototype, "_functionalChecklists", void 0);
    __decorate([
        observable
    ], MyFunctionChecklists.prototype, "_promiseLoaded", void 0);
    __decorate([
        action.bound
    ], MyFunctionChecklists.prototype, "_loadFunctionalChecklists", null);
    MyFunctionChecklists = __decorate([
        observer
    ], MyFunctionChecklists);
    return MyFunctionChecklists;
}(React.PureComponent));
